<template>
  <div class="partner-wrap ptb-100">
    <div class="container">
      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="partner-slider"
      >
        <Slide v-for="partner in partners" :key="partner.id">
          <div class="partner-item style2">
            <img :src="partner.image" alt="Image" />
          </div>
        </Slide>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide } from "vue3-carousel";

export default defineComponent({
  name: "OurPartner",
  components: {
    Carousel,
    Slide,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    partners: [
      {
        id: 1,
        image: require("../../assets/images/partner/partner-1.png"),
      },
      {
        id: 2,
        image: require("../../assets/images/partner/partner-2.png"),
      },
      {
        id: 3,
        image: require("../../assets/images/partner/partner-3.png"),
      },
      {
        id: 4,
        image: require("../../assets/images/partner/partner-4.png"),
      },
      {
        id: 5,
        image: require("../../assets/images/partner/partner-5.png"),
      },
      {
        id: 6,
        image: require("../../assets/images/partner/partner-6.png"),
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      768: {
        itemsToShow: 3,
        snapAlign: "center",
      },
      992: {
        itemsToShow: 4,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 5,
        snapAlign: "center",
      },
    },
  }),
});
</script>